import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactExtensionModule } from './extensions/c6e660947bba2eaf69fac4c48432effafaea489dff4d0d938ab67c6ae3b2f820/contact-ui-extension.module';
import { BlogNavModule } from './extensions/e45097dda8807f1b304131aee85449a7bce3d4dd8df89cb4b46e77c499e0dc2c/blog-nav.module';



@NgModule({
    imports: [CommonModule, ContactExtensionModule, BlogNavModule],
    providers: [],
})
export class SharedExtensionsModule {}
